<template>
  <span :class="[$style['loading-spinner'], $style[size]]" :style="spinnerStyle"></span>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "large"].includes(value),
    },
    color: {
      type: String,
      default: "#FFF",
    },
  },
  computed: {
    spinnerStyle() {
      return {
        borderColor: `${this.color} transparent transparent transparent`,
      };
    },
  },
};
</script>

<style lang="scss" module>
  .loading-spinner {
    display: inline-block;
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1.2s linear infinite;

    &.small {
      width: 20px;
      height: 20px;
      border-width: 2px;
    }

    &.medium {
      width: 40px;
      height: 40px;
    }

    &.large {
      width: 60px;
      height: 60px;
      border-width: 6px;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
